import clsx from "clsx";

export const StartPreOrderCancelSelectionButton = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        "w-full h-11 flex justify-center items-center bg-gray-100 border border-gray-400 font-medium text-gray-900 px-3 rounded-xl",
        className
      )}
    >
      선택하여 취소하기
    </button>
  );
};
